import { collection, doc, getDoc } from "firebase/firestore";

export async function getLockedVideoData({ db, video }) {
  try {
    /**
     * Fetch the system settings document. Use this document to
     * find the currently active campaign. Return an empty array
     * if no settings document or active campaign found.
     */

    const settingsRef = doc(db, "system", "settings");
    const settingsDoc = await getDoc(settingsRef);

    const settingsData = settingsDoc.data();
    if (!settingsData || !settingsData.activeCampaign) {
      return [];
    }

    /**
     * Fetch the active campaign document using the settings data
     * returned in the previous query. If no campaign document is
     * found, return an empty array.
     */

    const campaignRef = settingsData.activeCampaign;
    const campaignDoc = await getDoc(campaignRef);
    const campaignData = campaignDoc.data();
    if (!campaignData || !campaignData.title) {
      return [];
    }

    const learningPathCollectionRef = collection(campaignRef, "learningPath");
    const learningPathDocRef = doc(
      learningPathCollectionRef,
      video.prerequisite.learningPathId
    );

    const learningPathDoc = await getDoc(learningPathDocRef);
    const learningPathData = learningPathDoc.data();

    let prerequisiteVideo;

    if (learningPathData && learningPathData.videos) {
      learningPathData.videos.forEach((learningPathVideo) => {
        if (learningPathVideo.id === video.prerequisite.id) {
          prerequisiteVideo = learningPathVideo;
        }
      });
    }

    return {
      video: video,
      prerequisiteLearningPath: learningPathData,
      prerequisiteVideo: prerequisiteVideo,
    };
  } catch (error) {
    console.log(error);
  }
}

export async function checkShouldDisplayProgressNotification({
  learningPath,
  video,
}) {
  try {
    let response = {
      lastWatchedVideo: video,
    };

    let totalNumVideosInCampaign = 0;
    let numCompletedVideosInCampaign = 0;

    let totalNumVideosInLastWatchedPath = 0;
    let numCompletedVideosInLastWatchedPath = 0;

    let lastWatchedLearningPath;

    learningPath.forEach((learningPath) => {
      if (learningPath.videos) {
        learningPath.videos.forEach((learningPathVideo) => {
          /**
           * Track total number of videos in campaign and number of completed videos
           * in the campaign. This allows us to calculate the win condition.
           */

          totalNumVideosInCampaign++;

          if (
            learningPathVideo.progress &&
            learningPathVideo.progress.percent === 1
          ) {
            numCompletedVideosInCampaign++;
          }

          /**
           * Track the number of videos in section that the last watched video is in.
           * Increment total num counter and completed video counter. This allows us to
           * tell if the user has completed all videos in an individual learning path.
           */

          if (learningPath.id === video.learningPathId) {
            totalNumVideosInLastWatchedPath++;

            if (!lastWatchedLearningPath) {
              lastWatchedLearningPath = learningPath;
            }

            if (
              learningPathVideo.progress &&
              learningPathVideo.progress.percent === 1
            ) {
              numCompletedVideosInLastWatchedPath++;
            }
          }
        });
      }
    });

    /**
     * If all videos in the campaign are complete, all isLearningPathComplete key to the
     * response object.
     */
    if (numCompletedVideosInCampaign === totalNumVideosInCampaign) {
      response.isLearningPathComplete = true;
    }

    /**
     * If the user completed a section by watching the last video, append the completed
     * learning path doc to the learningPathComplete key in the response object.
     */
    if (
      numCompletedVideosInLastWatchedPath === totalNumVideosInLastWatchedPath
    ) {
      response.learningPathComplete = lastWatchedLearningPath;
    }

    return response;
  } catch (error) {
    console.log(error);
  }
}
